module.exports = __webpack_public_path__ + "media/audio7.9e8f3538.mp3";